import { version } from '../../package.json'

const versionNumber = version

export default versionNumber
